import { render, staticRenderFns } from "./TermsUpdate.vue?vue&type=template&id=29fb9235&scoped=true&"
import script from "./TermsUpdate.vue?vue&type=script&lang=js&"
export * from "./TermsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TermsUpdate.vue?vue&type=style&index=0&id=29fb9235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb9235",
  null
  
)

export default component.exports